// extracted by mini-css-extract-plugin
module.exports = {"avatar":"TbfiOJVNEX5RQn_jp1YYc"};